import React from "react";
import { connect } from "react-redux";
import Grid from "@mui/material/Grid";
import FormField from "../../../FormField";
import Button from "../../../Button/index";
import { withRouter } from "react-router-dom";
import { logout } from "../../../../actions/authActions";
import formValidation from "../../../../utils/formValidation";
import { saveProfile } from "../../../../actions/profileActions";

const hasLowerCase = RegExp(/(.*[a-z].*)/);
const hasUpperCase = RegExp(/(.*[A-Z].*)/);
const hasDigit = RegExp(/(.*\d.*)/i);
const hasSpecial = RegExp(/(.*\W.*)/i);
const isEmail = RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);

class UserProfile extends React.Component {
  fieldsValidation = {
    given_name: {
      error: "",
      validate: "text",
      minLength: 2,
      maxLength: 40,
    },
    family_name: {
      error: "",
      validate: "text",
      minLength: 2,
      maxLength: 40,
    },
    username: {
      error: "",
      validate: "username",
      minLength: 4,
      maxLength: 20,
    },
    email: {
      error: "",
      validate: "email",
    },
    password: {
      error: "",
      validate: "strongPassword",
      minLength: 8,
      maxLength: 30,
    },
    current_password: {
      error: "",
      validate: "strongPassword",
      minLength: 8,
      maxLength: 30,
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      values: {
        given_name: this.props.profile?.given_name,
        family_name: this.props.profile?.family_name,
        email: this.props.profile?.email,
        organization: this.props.profile?.organizations && this.props.profile?.organizations[0] ? this.props.profile?.organizations[0].display_name : null
      },
      errors: {},
      hasLowerCase: false,
      hasUpperCase: false,
      hasDigit: false,
      hasSpecial: false,
      hasEnoughLength: false,
      isEmailAvailable: false,
      isFirstnameValid: false,
      isLastnameValid: false,
      startValidating: false,
    };
    this.handleChange.bind(this);
    this.isValidField.bind(this);
  }

  handleChange(name, event) {
    this.setState({ startValidating: true });
    const value = event.target.value;
    let values = this.state.values;
    values[name] = value;
    this.setState(values);
    let error = formValidation(name, value, this.fieldsValidation);
    let errors = this.state.errors;
    errors[name] = error;
    this.setState(errors);
    if (name === "confirmPassword") {
      this.handleConfirmPassword(event);
    }
    this.handleBottomMessages(name, event);
  }

  handleBottomMessages(name, event) {
    const value = event.target.value;

    if (name === "password" || name === "currentPassword") {
      this.setState({ hasLowerCase: hasLowerCase.test(value) });
      this.setState({ hasUpperCase: hasUpperCase.test(value) });
      this.setState({ hasDigit: hasDigit.test(value) });
      this.setState({ hasSpecial: hasSpecial.test(value) });
      this.setState({ hasEnoughLength: value.length > 7 });
    } else if (name === "email") {
      this.setState({ isEmailAvailable: isEmail.test(value) });
    } else if (name === "given_name") {
      this.setState({
        isFirstnameValid: value.length > 2 && value.length < 40,
      });
    } else if (name === "family_name") {
      this.setState({ isLastnameValid: value.length > 2 && value.length < 40 });
    }
  }

  handleConfirmPassword(event) {
    const value = event.target.value;
    if (this.state.values.password !== value) {
      let errors = this.state.errors;
      errors.confirmPassword = "Passwords don't match";
      this.setState(errors);
    } else {
      let errors = this.state.errors;
      errors.confirmPassword = null;
      this.setState(errors);
    }
  }

  isValid() {
    for (const [key, value] of Object.entries(this.state.values))
      if (value == null || value.length === 0) return false;
    for (const [key, value] of Object.entries(this.state.errors))
      if (value != null) return false;
    return true;
  }

  isValidField(e) {
    if (this.state.startValidating === true) {
      return !this.state?.errors[e] && this.state.values[e]?.length > 0;
    }
  }

  isInvalidField(e) {
    return this.state?.errors[e];
  }

  handleFormSubmit(event) {
    event.preventDefault();
    this.props.saveProfile(
      {
        "given_name": this.state.values.given_name ? this.state.values.given_name : this.props.profile.given_name,
        "family_name": this.state.values.family_name ? this.state.values.family_name : this.props.profile.family_name,
      }
    );
  }

  render() {
    return (
      <>
        <form onSubmit={this.handleFormSubmit.bind(this)}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <FormField label="First Name" id="given_name">
                <input id="given_name" type="text" placeholder="Enter First Name" defaultValue={this.props.profile?.given_name} onChange={(e) => this.handleChange("given_name", e)} />
              </FormField>
            </Grid>
            <Grid item xs={6}>
              <FormField label="Last Name" id="family_name">
                <input id="family_name" type="text" placeholder="Enter Last Name" defaultValue={this.props.profile?.family_name} onChange={(e) => this.handleChange("family_name", e)} />
              </FormField>
            </Grid>
          </Grid>
          <FormField label="Email" id="email">
            <input id="email" type="email" placeholder="Enter Email" defaultValue={this.props.profile?.email} disabled={true} />
          </FormField>
          <FormField label="Organization" id="organization">
            <input id="organization" type="organization" defaultValue={this.props.profile?.organizations && this.props.profile?.organizations[0] ? this.props.profile?.organizations[0].display_name : null} disabled={true} />
          </FormField>
          <Button type="submit" style={{ width: '80%', height: '30px', marginLeft: '10%', marginBottom: '2rem', marginTop: '2rem' }}>
            Save Profile
          </Button>
        </form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.profile.loading,
  error: state.profile.error,
  profile: state.profile.profile,
});

export default withRouter(
  connect(mapStateToProps, { logout, saveProfile })(UserProfile)
);